import $axios from '@/plugins/axios-instance'

export default {
    state: {
        announcementList: []
    },

    getters: {
        getnannouncementList(state) {
            return state.announcementList
        }
    },

    actions: {
        getannouncement(context) {
            return  $axios.get('/announcement/GetAll?isActual=false')
            .then((response) => {
                context.state.announcementList = response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },
        
        announcementList(context) {

            return  $axios.get('/announcement/List')
            .then((response) => {
                context.state.newsList = response.data
            }).catch((e)=>{
                throw(e.response)
            })

        },
        
        announcementDetail(context, data) {
            return  $axios.get('/announcement/Get/'+data.id)
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },
        
        announcementCreate(context, data) {

            return $axios.post('/announcement/Create', data)
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
            
        },
        
        announcementEdit(context, data) {
            return $axios.post('/announcement/Edit/'+data.id, data)
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },
        
        announcementDelete(context, data) {

            return $axios.delete('/announcement/delete/'+data.id)
            .then((response) => {
                context.state.announcementList.splice(data.index, 1)
            }).catch((e)=>{
                throw(e.response)
            })

        },


    }
}